import { useQuery } from "@tanstack/react-query";
import { api } from "../../libs/axios";
import { CheckoutProgress } from "../../utils/interfaces";

async function getCheckoutStatus(id: string): Promise<CheckoutProgress> {
  const response = await api.get(`/checkout/status/${id}`);

  return response.data?.data as CheckoutProgress;
}

export function useCheckoutStatus(id: string, enabled = true) {
  return useQuery({
    queryKey: ["checkout-status", { id }],
    queryFn: () => getCheckoutStatus(id),
    enabled,
    refetchInterval: enabled ? 3000 : false,
    retry: false,
    staleTime: 0,
  });
}
